import AxiosInstance from "./Axios";
import Cookies from "universal-cookie";

// POST /tree-reports/ibs
//
// Given a list of tree ids (typically the trees where the logged-in user is
// Master IB, from GET /tree-reports/trees), returns the IBs that belong to
// those trees, e.g.:
//
// Request body:
// { "tree_ids": [1000] }
//
// Response:
// {
//   "status": "Success",
//   "data": [
//     { "ib_email": "business@olivermarkets.com", "ib_name": "Martin Olivera Markets" },
//     { "ib_email": "hcarreno@tvmarkets.com", "ib_name": "Hector Carreno" }
//   ]
// }
//
// Unlike /tree-reports/clients, this endpoint is not paginated - `data` is
// the full, flat list of IBs for the given trees.
const TreeIbsRequest = async (payload) => {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    const res = await AxiosInstance.post("/tree-reports/ibs", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res;
  } catch (error) {
    console.error("error in request:", error);
    throw error;
  }
};

export default TreeIbsRequest;